var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statisDiv",style:({width: _vm.width, height: _vm.height})},[_c('div',{staticClass:"contentClass"},[_c('img',{staticClass:"gemstoneClass",attrs:{"src":require("../src/assets/imgs/gemstoneImg.png"),"alt":""}}),_c('div',{staticClass:"describeClass"},[_vm._v(_vm._s(_vm.describeText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }